import { SimilarTechnologySummaryDto } from '@@types/api.types';
import { ConfidenceScore } from '@components/shared/confidence-score.component';
import { FC } from 'react';
import {
  SimilarTechnologiesSummaryContent,
  getOverallSimilarTechnologiesConfidence,
} from './similar-technologies-summary-content.component';

type SimilarTechnologiesSuggestionContentProps = {
  summary: SimilarTechnologySummaryDto;
};

export const SimilarTechnologiesSuggestionContent: FC<SimilarTechnologiesSuggestionContentProps> = (props) => {
  const { summary } = props;

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center gap-3">
        <ConfidenceScore
          design="box"
          score={getOverallSimilarTechnologiesConfidence(summary)}
          size="small"
        />
        <div className="flex flex-col leading-tight">
          <span className="text-sm font-medium text-gray-800">Similar Technologies</span>
          <span className="text-xs text-gray-500">Confidence Score</span>
        </div>
      </div>
      <SimilarTechnologiesSummaryContent summary={summary} />
    </div>
  );
};
